import type {
	BeneficiaryListItemPayload,
	ComputedBeneficiaryListItemPayload,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiariesFetched';
import computeBeneficiaryPayload from '@Application/Beneficiaries/Beneficiaries/Actions/computeBeneficiaryPayload';

// `PUT …/status` answers `LIST_SERIALIZATION_GROUPS`, without the INS: archiving does not touch
// identity, so this action deliberately carries the list-item shape, not the detail one.
export type BeneficiaryArchivedAction = {
	type: 'BENEFICIARY_ARCHIVED';
	payload: ComputedBeneficiaryListItemPayload;
	facilityId: number;
};

export default (payload: BeneficiaryListItemPayload, facilityId: number): BeneficiaryArchivedAction => ({
	type: 'BENEFICIARY_ARCHIVED',
	payload: computeBeneficiaryPayload(payload),
	facilityId,
});
